'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  folder: crud('folder'),
  file: crud('file'),
  task: crud('task'),
  job: crud('job'),
  upload: function upload(folder_id, files) {
    var data = new FormData();
    for (var i = 0; i < files.length; i++) {
      data.append('file', files[i]);
    }
    return fetch('/folders/' + folder_id, postBody(data)).then(function (req) {
      return req.json();
    }).catch(error);
  }
};


function crud(type_s) {
  var type = '/' + type_s + 's/';
  return {
    index: function index(data) {
      return fetch(_get_url(type, data), _get_headers()).then(function (req) {
        return req.json();
      }).catch(error);
    },

    show: function show(id) {
      return fetch(type + id).then(function (req) {
        return req.json();
      }).catch(error);
    },

    create: function create(data) {
      return fetch(type, post(data)).then(function (req) {
        return req.json();
      }).catch(error);
    },

    update: function update(data) {
      return fetch(type + data.id, put(data)).then(function (req) {
        return req.json();
      }).catch(error);
    },

    destroy: function destroy(data) {
      return fetch(type + data.id, _destroy(data)).then(function (req) {
        return req.json();
      }).catch(error);
    }
  };
}

function _get_url(_url, data) {
  var url = new URL(window.location.origin + _url);
  if (data) {
    Object.keys(data).forEach(function (key) {
      return url.searchParams.append(key, data[key]);
    });
  }
  return url;
}
function _get_headers() {
  return {
    method: 'GET',
    headers: {
      'Accept': 'application/json'
    }
  };
}
function post(data) {
  return {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  };
}
function postBody(data) {
  return {
    method: 'POST',
    body: data,
    headers: {
      'Accept': 'application/json'
    }
  };
}
function put(data) {
  return {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  };
}
function _destroy(data) {
  return {
    method: 'DELETE',
    body: JSON.stringify(data),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  };
}
function error(err) {
  console.warn(err);
}


//////////////////
// WEBPACK FOOTER
// ./client/client.js
// module id = 7
// module chunks = 0